export class ReferenceDto {

  id: string;

  type: string;

}
